import apiService from 'src/enviroment';
import convertDate from '../utils/formatDate';

const getReportDataStudioLucia = async () => {
  const { status, data } = await apiService.get(
    '/admin/datastudio/reportes/all/',
  );
  try {
    if (status === 200 && data.success === 1) {
      return data.data;
    }
    return false;
  } catch (err) {
    console.warn('getReportDataStudioLucia', err);
  }
};

const getReportDataStudioLuciaByAssigned = async () => {
  const { status, data } = await apiService.get(
    '/admin/datastudio/reportes/asignados/',
  );
  try {
    if (status === 200 && data.success === 1) {
      return data.data;
    }
    return false;
  } catch (err) {
    console.warn('getReportDataStudioLucia', err);
  }
};

const getReportByUser = async (userEmail) => {
  const { status, data } = await apiService.get(
    `/admin/datastudio/reportes/usuario/auth/?correo=${userEmail}`,
  );
  try {
    if (status === 200 && data.success === 1) {
      return data;
    }
    return [];
  } catch (err) {
    console.log('getReportDataStudioLucia', err);
  }
};

const getReportsDataStudio = async () => {
  const { status, data } = await apiService.get(
    '/admin/datastudio/reportes/auth/',
  );
  try {
    if (status === 200 && data.success === 1) {
      return data;
    }
    return false;
  } catch (err) {
    console.warn('getReportDataStudioLucia', err);
  }
};

const postReportDataStudio = async (param) => {
  const { status, data } = await apiService.post(
    '/admin/datastudio/reportes/',
    param,
  );
  try {
    if (status === 200 && data.success === 1) {
      return true;
    }
    return false;
  } catch (err) {
    console.warn('postReportDataStudio', err);
  }
};

const deleteReportDataStudio = async (id) => {
  const { status, data } = await apiService.delete(
    `/admin/datastudio/reportes/?id=${id}`,
  );
  try {
    if (status === 200 && data.success === 1) {
      return true;
    }
    return false;
  } catch (err) {
    console.warn('deleteReportDataStudio', err);
  }
};

const getPermitsReport = async (reportId) => {
  const { status, data } = await apiService.get(
    `/admin/datastudio/usuarios/?reporte_id=${reportId}`,
  );

  try {
    if (status === 200 && data.success === 1) {
      return data;
    }
    return false;
  } catch (err) {
    console.warn('deleteReportDataStudio', err);
  }
};

const postPermitUser = async (params) => {
  const { status, data } = await apiService.post(
    '/admin/datastudio/usuarios/',
    params,
  );
  try {
    if (status === 200) {
      return data;
    }
    return false;
  } catch (err) {
    console.warn('postPermitUser', err);
  }
};

const deletePermit = async (params) => {
  const { status, data } = await apiService.delete(
    `/admin/datastudio/usuarios/?id=${params}`,
  );
  try {
    if (status === 200) {
      return data;
    }
    return false;
  } catch (err) {
    console.warn('postPermitUser', err);
  }
};

const getReportByUserPermit = async () => {
  const { status, data } = await apiService.get('/admin/datastudio/reportes/');
  try {
    if (status === 200 && data.success === 1) {
      return data;
    }
    return false;
  } catch (err) {
    console.warn('postPermitUser', err);
  }
};

const reportsService = {
  /*= =======================================================================
  Admin Providers
======================================================================== */

  postPrivedersSegmentation: (body) => apiService.post('/reportes/proveedores/segmentacion/', body),
  postProviderZone: (body) => apiService.post('/reportes/proveedores/zonas/', body),
  post3W: (body) => apiService.post('/reportes/proveedores/3w/', body),
  postMotorcicles: (body) => apiService.post('/reportes/proveedores/motocicletas/', body),
  postMotorciclesAnd3w: (body) => apiService.post('/reportes/proveedores/exportar/', body),
  getCategorys: () => apiService.get('/reportes/proveedores/categorias/'),

  /*= =======================================================================
  Admin Reoorts
======================================================================== */

  getPermitsReport,
  postPermitUser,
  deletePermit,
  /*= =======================================================================
  Data Estudio Reports
======================================================================== */
  getReportDataStudioLuciaByAssigned,
  getReportDataStudioLucia,
  getReportByUserPermit,
  getReportsDataStudio,
  postReportDataStudio,
  getReportByUser,
  putReportDataStudio: (params) => apiService.put('/admin/datastudio/reportes/', params),
  deleteReportDataStudio,

  /*= =======================================================================
  Mobility Repors Reports
======================================================================== */
  postMobilitySegmentation: (params) => apiService.post('/reportes/mobility/segmentacion/', params),
  postMobilityCampos: (params) => apiService.post('/reportes/mobility/campos/', params),
  postCSVMobility: (params) => {
    const body = {
      captcha: params.captcha,
      fecha_0: convertDate(params.fecha_0),
      fecha_1: convertDate(params.fecha_1),
    };
    return apiService.post('/reportes/mobility/exportar/', body);
  },

  putCSVMobility: (params) => apiService.put('/reportes/mobility/exportar/', params),

  /*= =======================================================================
  Docuementos && Placas Repors Reports
======================================================================== */

  postPlaca: (params) => apiService.post('/reportes/buscador/placa/', params),
  postDocument: (params) => apiService.post('/reportes/buscador/cedulas/', params),
  postPoints: (params) => apiService.post('/reportes/buscador/puntaje/', params),
};

export default reportsService;
